import React from "react";
import { default as WMenu } from "@mui/material/Menu";

function Menu(props) {
  return <WMenu {...props} />;
}

export default Menu;
